import PropTypes from 'prop-types';
import React, { useState, useContext, useMemo, useCallback } from 'react';
import { InventoryContext } from './inventory-create-context';

export const useInventory = () => useContext(InventoryContext);

export const InventoryProvider = ({ children }) => {
    const [productSKUS, setProductSKUS] = useState([]);
    const [inventories, setInventories] = useState([]);
    const [quantity, setQuantity] = useState('')
    const[calculationtype,setCalculationType]=useState(null)
    const[calculationquantity,setcalculationtypequantity]=useState(null)
   const [isallocablecalculated,setisallocablecalculated]=useState(null)
    const [workOrderObject, setWorkOrderObject] = useState({});
    const [completePurchase, setcompletePurchase] = useState({});
    const [completeOrder,setcompleteOrder]=useState([])
    const [jobpayload,setjobpayload]=useState([])
    console.log('Complete purchase in provider:', completePurchase);
    console.log('Complete order in provider:', completeOrder);

    const updatecompletePurchase = useCallback((object) => {
        setcompletePurchase(object);
    }, []);

       const updatejobpayload = useCallback((object) => {
        setjobpayload(object);
    }, []);

      const updateisallocablecalculated = useCallback((object) => {
        setisallocablecalculated(object);
    }, []);

     const updatecalculationquantity = useCallback((object) => {
        setcalculationtypequantity(object);
    }, []);

      const updatecalculationtype = useCallback((object) => {
        setCalculationType(object);
    }, []);

      const updatecompleteOrder = useCallback((object) => {
        setcompleteOrder(object);
    }, []);
    const updateWorkOrderObject = useCallback((object) => {
        setWorkOrderObject(object);
    }, []);

    const updateQuantity = useCallback((newQuantity) => {
        setQuantity(newQuantity);
    }, []);

    const updateProductSKUS = useCallback((newSKUS) => {
        setProductSKUS(newSKUS);
    }, []);

    const updateInventories = useCallback((newInventories) => {
        setInventories(newInventories);
    }, []);

    const contextValue = useMemo(() => ({
        inventories,
        productSKUS,
        quantity,
        workOrderObject,
        completePurchase,
        updateProductSKUS,
        updateInventories,
        updateQuantity,
        updateWorkOrderObject,
        updatecompletePurchase,
        updatecompleteOrder,
        completeOrder,
        updatecalculationtype,
        calculationtype,
        calculationquantity,
        updatecalculationquantity,
        isallocablecalculated,
        updateisallocablecalculated,
        updatejobpayload,
        jobpayload

    }), [inventories, productSKUS, quantity, completePurchase, workOrderObject, updateInventories, updateProductSKUS, updateQuantity, updateWorkOrderObject, updatecompletePurchase,updatecompleteOrder,completeOrder,updatecalculationtype,calculationtype,updatecalculationquantity,calculationquantity,isallocablecalculated,updateisallocablecalculated,updatejobpayload,jobpayload]);

    return (
        <InventoryContext.Provider value={contextValue}>
            {children}
        </InventoryContext.Provider>
    );
};

InventoryProvider.propTypes = {
    children: PropTypes.node,
};